<template>
    <v-container fluid>
        <v-row class="pl-13 pr-4">
            <v-col cols="1">
                <v-img 
                    :src="item.picture ? item.picture : require('@/assets/default_picture/default.jpg')"
                    :alvqa="alvqa + '-list-row-' + item.alvId + '-image'"
                >
                </v-img>
            </v-col>
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-address'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_ADDRESS') }}:
                                <BaseIcon   
                                    :alvqa="alvqa + '-icon-address-copy-to-clipboard'"
                                    :small="true"
                                    icon="content_copy" 
                                    color="buttonStandard"
                                    @click.stop="copyToClipboard($alvPlugin.getAddressInternational(item))"
                                />
                            </div>
                             <span :alvqa="alvqa + '-address'" 
                                v-html="$alvPlugin.getAddressInternational(item)"></span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- ALVID -->
                        <span v-if="item.alvId != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-alvid'"
                            >{{ item.alvId }}</div>
                        </span>

                        <!-- TYPE -->
                        <span v-if="item.type != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-type'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_TYPE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-type'"
                            >{{ $alvPlugin.getAzTypes(item.type) }}</div>
                        </span>

                        <!-- EMAIL -->
                        <span v-if="item.email != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-email'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_EMAIL') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-email'"
                            >{{ item.email }}</div>
                        </span>

                        <!-- CELLPHONE -->
                        <span v-if="item.cellphone != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-cellphone'"
                            >{{ $t('lang_AZ_PERSONS_CAPTION_CELLPHONE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-cellphone'"
                            >{{ item.cellphone }}</div>
                        </span>

                        <!-- PHONE -->
                        <span v-if="item.phone != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-phone'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_PHONE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-phone'"
                            >{{ item.phone }}</div>
                        </span>

                        <!-- FAX -->
                        <span v-if="item.fax != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-fax'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_FAX') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-fax'"
                            >{{ item.fax }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        
                        <!-- GEMA NAME -->
                        <span v-if="item.gemaName != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-gema-name'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_GEMA_NAME') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-gema-name'"
                            >{{ item.gemaName }}</div>
                        </span>

                        <!-- WEB -->
                        <span v-if="item.web != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-web'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_WEB') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-web'"
                            ><a :href="item.web.startsWith('http') ? item.web : 'https://' + item.web" target="_blank">{{ item.web }}</a></div>
                        </span>

                        <!-- FACEBOOK -->
                        <span v-if="item.facebook != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-facebook'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_FACEBOOK') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-facebook'"
                            >{{ item.facebook }}</div>
                        </span>

                        <!-- YOUTUBE -->
                        <span v-if="item.youtube != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-youtube'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_YOUTUBE') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-youtube'"
                            >{{ item.youtube }}</div>
                        </span>

                        <!-- TWITTER -->
                        <span v-if="item.twitter != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-twitter'"
                            >{{ $t('lang_GENERIC_AZ_CAPTION_TWITTER') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-twitter'"
                            >{{ item.twitter }}</div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="pl-4 pr-4">
            <v-col v-if="item.notes != '' && item.notes != null">
                <!-- NOTES -->
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.notes != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERIC_CAPTION_NOTES') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-notes'"
                            >{{ item.notes }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="item.tags != '' && item.tags != null">
                <!-- TAGs -->
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.tags != null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-tags'"
                            >{{ $t('lang_GENERIC_CAPTION_TAGS') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-tags'"
                            >{{ item.tags }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <!-- RELEASES Panel -->
                    <AzPersonsReleasesReadOnlyPanel :azPersonsAlvId="item.alvId"/>
                    <!-- METADATA Panel -->
                    <AzPersonsMetadataReadOnlyPanel :azPersonsAlvId="item.alvId"/>
                    <!-- MAPPINGS Panel -->
                    <AzPersonsMappingsReadOnlyPanel :azPersonsAlvId="item.alvId"/>
                    <!-- FINANCE Panel -->
                    <AzPersonsFinanceReadOnlyPanel :azPersonsAlvId="item.alvId"/>
                    <!-- OTHER IDs Panel -->
                    <AzPersonsOtherIdsReadOnlyPanel/>
                    
                    <!-- ARTIST PORTAL Panel -->
                    <ArtistPortalAccess v-if="item" :az-id="item.alvId" :initial-email="item.email || ''" />
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ArtistPortalAccess from '@/components/ArtistPortalAccess'
import BaseIcon from '@/components/_buttons/BaseIcon'
import AzPersonsMetadataReadOnlyPanel from './_panels/AzPersonsMetadataReadOnlyPanel'
import AzPersonsMappingsReadOnlyPanel from './_panels/AzPersonsMappingsReadOnlyPanel'
import AzPersonsFinanceReadOnlyPanel from './_panels/AzPersonsFinanceReadOnlyPanel'
import AzPersonsOtherIdsReadOnlyPanel from './_panels/AzPersonsOtherIdsReadOnlyPanel'
import AzPersonsReleasesReadOnlyPanel from './_panels/AzPersonsReleasesReadOnlyPanel'

export default {
    name: "AzPersonsReadOnly",
    components: {
        ArtistPortalAccess,
        AzPersonsMetadataReadOnlyPanel,
        AzPersonsMappingsReadOnlyPanel,
        AzPersonsFinanceReadOnlyPanel,
        AzPersonsOtherIdsReadOnlyPanel,
        AzPersonsReleasesReadOnlyPanel,
        BaseIcon,
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            alvqa: 'az-persons-list-read-only'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedAzPersons.find(element => {
                return element.id === this.itemId
            })

            return item
        },
    },
    methods: {
        copyToClipboard(item) {
            let address = item.replace(/<br\s*[\/]?>/gi, "\n")
            navigator.clipboard.writeText(address);
        },
    },
    created() {
        this.$store.commit('setCountries')
    }
}
</script>